import ProjectCard from "components/Project-Card";
import UpslidingText from "components/Upsliding-Text";
import { db } from "db";
import { collection, getDocs } from "firebase/firestore";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

const WorkSection = ({ work = null }) => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    let projectsCollection = collection(db, "projects");
    getDocs(projectsCollection).then((res) => {
      let projects = [];
      res.docs.forEach((doc) => {
        projects.push({ id: doc.id, ...doc.data() });
      });
      setProjects(projects);
    });
  }, []);

  return (
    <div className={`${work ? `mt-24 md:mt-48` : `mt-32 md:mt-72`}`}>
      {!work && (
        <div className='flex justify-center'>
          <div className='mt-8'>
            <div className='flex justify-center'>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                F
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                e
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                a
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                t
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                u
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                r
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                e
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                d
              </p>
            </div>
            <div className='flex justify-center'>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                W
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                o
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                r
              </p>
              <p className='text-dark dark:text-light heading-super-2 font-bold '>
                k
              </p>
            </div>
          </div>
        </div>
      )}
      <div className='mt-24 md:mt-48'>
        {projects
          .sort((a, b) => {
            if (moment(a.date).isBefore(moment(b.date))) {
              return 1;
            }
            if (moment(a.date).isAfter(moment(b.date))) {
              return -1;
            }
            return 0;
          })
          .filter((project, index) => {
            if (work) {
              return true;
            }
            return index < 3;
          })
          .map((project, index) => {
            if (index % 2 === 0) {
              return (
                <div className='flex flex-col md:flex-row justify-end mt-16 md:mt-32 gap-8 items-stretch'>
                  <p className='md:basis-1/2 text-lg text-dark dark:text-light md:text-xl lg:text-3xl md:text-right'>
                    {project.title}
                    <br />
                    {project.description}
                  </p>
                  <ProjectCard
                    image={project.src}
                    color={"bg-dark2"}
                    name={project.title}
                    date={project.date}
                    onClick={(e) => {
                      window.open(project.view, "_blank");
                    }}
                  />
                </div>
              );
            }
            return (
              <div className='flex flex-col md:flex-row justify-start mt-16 md:mt-32 gap-8 items-stretch'>
                <ProjectCard
                  image={project.src}
                  color={"bg-light2"}
                  name={project.title}
                  date={project.date}
                  onClick={(e) => {
                    window.open(project.view, "_blank");
                  }}
                />
                <p className='md:basis-1/2 text-lg text-dark dark:text-light md:text-xl lg:text-3xl'>
                  {project.title}
                  <br />
                  {project.description}
                </p>
              </div>
            );
          })}
      </div>
      {!work && (
        <UpslidingText
          text={"View more"}
          textCenter
          marginTop
          color={"text-dark dark:text-light"}
          onClick={(e) => {
            window.scrollTo(0, 0);
            navigate("/work");
          }}
        />
      )}
    </div>
  );
};

export default WorkSection;
